import { render, staticRenderFns } from "./ManagersView.vue?vue&type=template&id=c74deb48"
import script from "./ManagersView.vue?vue&type=script&lang=js"
export * from "./ManagersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports